import { IAction } from "../utils";
import { reducerTypes } from "./types";
import { IPageInfo } from "../../interfaces/common";
import { IModel } from "../../interfaces/product";

export interface IModelReducer {
  pageInfo: IPageInfo;
  models: IModel[];
  modelsMore: IModel[];
  model?: IModel;
  loading: boolean;
}

export const INITIAL: IModelReducer = {
  pageInfo: {
    pageIndex: -1,
    totalPages: 0,
    totalCount: 0,
    pageSize: 12,
  },
  models: [],
  modelsMore: [],
  loading: false,
};

export const modelReducer = (state = INITIAL, { type, payload }: IAction) => {
  switch (type) {
    case reducerTypes.IS_LOADING:
      return { ...state, loading: payload };
    case reducerTypes.GET_ALL_MODELS:
      return {
        ...state,
        models: payload,
        modelsMore: payload,
        loading: false,
      };
    case reducerTypes.GET_MORE_MODELS:
      return {
        ...state,
        modelsMore: [...state.modelsMore, ...payload],
        loading: false,
      };
    case reducerTypes.GET_MODEL:
      return { ...state, model: payload };
    case reducerTypes.SET_PAGE_INFO:
      return { ...state, pageInfo: payload };
    case reducerTypes.SET_PAGE_INDEX:
      return { ...state, pageInfo: { ...state.pageInfo, pageIndex: payload } };
    case reducerTypes.SET_PAGE_SIZE:
      return { ...state, pageInfo: { ...state.pageInfo, pageSize: payload } };
    default:
      return state;
  }
};
